 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		45: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		45: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-locations-LocationsPage-LocationsPageContainer","39":"app-components-search-Search-SearchContainer","40":"app-components-search-SearchPrintList-SearchPrintListContainer","41":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","42":"app-components-shelves-Shelf-ShelfContainer","43":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","44":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"52d546d2053983eb7ef0","1":"c88c5805a811d9906856","2":"d961f2c880e4d57b5f31","3":"7adbc32146ccf54ec3a3","4":"6e5e53baf1ed25782a6e","5":"84d0f170b65da5a64c67","6":"1b5bab34d8cf2c47f061","7":"8f39fcdae97db305e78b","8":"554c3e35dcdd625f31d1","9":"1dfd0e72d7273cedf7f2","10":"351ac68a19f3422005d1","11":"bf16f643bc282898d471","12":"5ead3be7e22fa53b2f5b","13":"50a5eba4294a531e80ab","14":"c94926b621445409f51b","15":"72b0ffe87cc25eac1460","16":"57544823d733a3ba3ac4","17":"5f94a166699cd7f3fd51","18":"20fec8f96b2bead49012","19":"f750c9b8b17f3ebe3d5b","20":"bdf7e305f7400c502796","21":"96905b7707910f79f8f7","22":"7fd80ba71bf15913719f","23":"8913c7ae17dd56ca40ab","24":"3cacd7d9986ef0f97f35","25":"dfdd41a937ce5eda4e01","26":"8440873b519add99d07c","27":"43de49a703d1f6914cc5","28":"f7a7ba0b7eb0b99aa2ae","29":"c1f7af4423baec01ccda","30":"91f6279e8cc3bdd9889d","31":"83f83ec6cc35b986a1a6","32":"8d18f51eb3834a72da78","33":"e7dc1bae2d253f248a45","34":"cb41d268b4c635cf8c3d","35":"5b0702c9fc6b28c9f537","36":"e4630af19b8ef8c774c1","37":"205a24d1a61f153776b0","38":"1dcefb75f799045bef56","39":"6c3b6511ed440ba447dc","40":"6a3330807ec6b562f9e0","41":"e46b6ea560631e2615ee","42":"bce882bbf7ff6582d8bd","43":"963f3a63e6e450075e2d","44":"ff4eae214c1805e8fceb","46":"0450e8b9ca67ddd8e295","47":"de86122cc165bac2a668","48":"2e6a55143c28164d7b47","49":"25696034a11171701332","50":"41891e12b30da133e743","51":"9aabfee33d7e9ccf6635","52":"f12c048567c03cd6d732"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-locations-LocationsPage-LocationsPageContainer","39":"app-components-search-Search-SearchContainer","40":"app-components-search-SearchPrintList-SearchPrintListContainer","41":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","42":"app-components-shelves-Shelf-ShelfContainer","43":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","44":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"52d546d2053983eb7ef0","1":"c88c5805a811d9906856","2":"d961f2c880e4d57b5f31","3":"7adbc32146ccf54ec3a3","4":"6e5e53baf1ed25782a6e","5":"84d0f170b65da5a64c67","6":"1b5bab34d8cf2c47f061","7":"8f39fcdae97db305e78b","8":"554c3e35dcdd625f31d1","9":"1dfd0e72d7273cedf7f2","10":"351ac68a19f3422005d1","11":"bf16f643bc282898d471","12":"5ead3be7e22fa53b2f5b","13":"50a5eba4294a531e80ab","14":"c94926b621445409f51b","15":"72b0ffe87cc25eac1460","16":"57544823d733a3ba3ac4","17":"5f94a166699cd7f3fd51","18":"20fec8f96b2bead49012","19":"f750c9b8b17f3ebe3d5b","20":"bdf7e305f7400c502796","21":"96905b7707910f79f8f7","22":"7fd80ba71bf15913719f","23":"8913c7ae17dd56ca40ab","24":"3cacd7d9986ef0f97f35","25":"dfdd41a937ce5eda4e01","26":"8440873b519add99d07c","27":"43de49a703d1f6914cc5","28":"f7a7ba0b7eb0b99aa2ae","29":"c1f7af4423baec01ccda","30":"91f6279e8cc3bdd9889d","31":"83f83ec6cc35b986a1a6","32":"8d18f51eb3834a72da78","33":"e7dc1bae2d253f248a45","34":"cb41d268b4c635cf8c3d","35":"5b0702c9fc6b28c9f537","36":"e4630af19b8ef8c774c1","37":"205a24d1a61f153776b0","38":"1dcefb75f799045bef56","39":"6c3b6511ed440ba447dc","40":"6a3330807ec6b562f9e0","41":"e46b6ea560631e2615ee","42":"bce882bbf7ff6582d8bd","43":"963f3a63e6e450075e2d","44":"ff4eae214c1805e8fceb","46":"0450e8b9ca67ddd8e295","47":"de86122cc165bac2a668","48":"2e6a55143c28164d7b47","49":"25696034a11171701332","50":"41891e12b30da133e743","51":"9aabfee33d7e9ccf6635","52":"f12c048567c03cd6d732"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2228);
